import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function OfferBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full bg-orange-500 text-white z-50 px-4 py-2 flex justify-center items-center shadow-lg" data-id="element-168">
      <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-xs sm:text-sm md:text-base font-bold text-center pr-8" data-id="element-169">
        <div className="flex items-center gap-2" data-id="element-170">
          <AlertTriangle size={18} data-id="element-171" />
          <span data-id="element-172">OFERTA POR TIEMPO LIMITADO: 50% OFF</span>
        </div>
        <div className="hidden sm:block w-1 h-1 bg-white/50 rounded-full" data-id="element-173"></div>
        <div className="flex items-center gap-2" data-id="element-174">
          <span data-id="element-175">
            Precio normal{' '}
            <span className="line-through opacity-80" data-id="element-176">$23,998</span> → HOY
            $11,999
          </span>
        </div>
        <div className="hidden sm:block w-1 h-1 bg-white/50 rounded-full" data-id="element-177"></div>
        <CountdownTimer compact={true} data-id="element-178" />
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors bg-black/20 p-1 rounded-full" aria-label="Cerrar oferta" data-id="element-179">
        <X size={16} data-id="element-180" />
      </button>
    </div>;
}